var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.2002 17.2998H9.59961C9.98621 17.2998 10.2998 17.6134 10.2998 18V22.7998C10.2998 23.1864 9.98621 23.5 9.59961 23.5H1.2002C0.813595 23.5 0.5 23.1864 0.5 22.7998V18C0.5 17.6134 0.813595 17.2998 1.2002 17.2998ZM14.4004 10.0996H22.7998C23.1863 10.0996 23.4999 10.4133 23.5 10.7998V22.7998C23.5 23.1864 23.1864 23.5 22.7998 23.5H14.4004C14.0138 23.5 13.7002 23.1864 13.7002 22.7998V10.7998C13.7003 10.4133 14.0139 10.0996 14.4004 10.0996ZM1.2002 0.5H9.59961C9.98621 0.5 10.2998 0.813596 10.2998 1.2002V13.2002C10.2997 13.5867 9.98614 13.9004 9.59961 13.9004H1.2002C0.813661 13.9004 0.500105 13.5867 0.5 13.2002V1.2002C0.5 0.813596 0.813596 0.5 1.2002 0.5ZM14.4004 0.5H22.7998C23.1864 0.5 23.5 0.813595 23.5 1.2002V6C23.5 6.3866 23.1864 6.7002 22.7998 6.7002H14.4004C14.0138 6.7002 13.7002 6.3866 13.7002 6V1.2002C13.7002 0.813596 14.0138 0.5 14.4004 0.5Z",
    stroke: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid);
export default __webpack_public_path__ + "static/media/Grid.243d4128c03dcab3b7e7e6b978d4100f.svg";
export { ForwardRef as ReactComponent };